import React, { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import "../../../assets/css/user/blogs/blogs.css";
import AppContext from "../../../context/AppContext";
import axios from "axios";
import { Spinner } from "react-bootstrap";

const ArrowRight = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2.5"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M5 12h14M12 5l7 7-7 7" />
  </svg>
);

const ArrowUpRight = () => (
  <svg
    width="14"
    height="14"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2.5"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M7 17L17 7M7 7h10v10" />
  </svg>
);

const BlogCard = ({ post, index, baseUrlForFiles }) => {
  const navigate = useNavigate();

  const categoryClass =
    {
      Beauty: "lb-cat-beauty",
      Business: "lb-cat-business",
      Technology: "lb-cat-technology",
    }[post.category] || "";

  return (
    <article
      className="lb-card"
      onClick={() => navigate(`/blog/detail/${post.id}`)}
      role="button"
      tabIndex={0}
      onKeyDown={(e) =>
        e.key === "Enter" && navigate(`/blog/detail/${post.id}`)
      }
    >
      <div className="lb-card-image-wrapper">
        <img
          src={`${baseUrlForFiles}/${post.image}`}
          alt={post.title}
          loading="lazy"
        />
        <div className="lb-card-image-overlay" />
        <span className={`lb-card-category ${categoryClass}`}>
          {post.category || "Blog"}
        </span>
        <div className="lb-card-number">0{index + 1}</div>
      </div>

      <div className="lb-card-body">
        <h3 className="lb-card-title">{post.title}</h3>
        <div
          className="lb-card-excerpt"
          dangerouslySetInnerHTML={{ __html: post.description }}
        />

        <div className="lb-card-footer">
          <div className="lb-card-author">
            <div className="lb-author-avatar">AD</div>
            <div className="lb-author-info">
              <span className="lb-author-name">Admin</span>
              <span className="lb-author-date">
                {new Date(post.created_at).toLocaleDateString("en-GB")}
              </span>
            </div>
          </div>
        </div>
      </div>

      <button
        className="lb-card-read-more"
        aria-label="Read more"
        onClick={(e) => {
          e.stopPropagation();
          navigate(`/blog/detail/${post.id}`);
        }}
      >
        Read More <ArrowUpRight />
      </button>
    </article>
  );
};

const LatestBlog = () => {
  const navigate = useNavigate();
  const { baseUrl, baseUrlForFiles } = useContext(AppContext);

  const [latestBlog, setLatestBlog] = useState([]);
  const [loading, setLoading] = useState(false);

  const fetchLatestBlogs = () => {
    setLoading(true);

    const formData = new FormData();
    formData.append("limit", 4); // ✅ 4 blogs taake grid poori bhare (pehle 3 thay)

    axios
      .post(`${baseUrl}/customer/blog/fetchLatestBlogs`, formData, {
        headers: { "Content-Type": "multipart/formData" },
      })
      .then((res) => {
        if (res.data.success) {
          setLatestBlog(res.data.blogs);
        }
        setLoading(false);
      })
      .catch((err) => {
        console.log(err);
        setLoading(false);
      });
  };

  useEffect(() => {
    fetchLatestBlogs();
  }, []);

  return (
    <section className="lb-section" id="blog">
      <div className="lb-container">
        <div className="lb-header">
          <div className="lb-header-left">
            <h2 className="lb-title">Latest from Blog</h2>
            <p className="lb-subtitle">
              News, tips and insights from Time4Pulse.
            </p>
          </div>
          <button className="lb-view-all" onClick={() => navigate("/blog")}>
            View All <ArrowRight />
          </button>
        </div>

        <div className="lb-grid">
          {loading ? (
            <div className="lb-loading">
              <Spinner animation="border" />
            </div>
          ) : (
            latestBlog.map((post, index) => (
              <BlogCard
                key={post.id}
                post={post}
                index={index}
                baseUrlForFiles={baseUrlForFiles}
              />
            ))
          )}
        </div>
      </div>
    </section>
  );
};

export default LatestBlog;
